/**
 * プロジェクトタイトル
 */
export const TITLE = {
  // タイトルバー
  TITLE_BAR: '地方創生SDGs官民連携マッチングシステム｜内閣府',
  // タイトルフッダー
  TITLE_FOOTER: '地方創生SDGs官民連携プラットフォーム',
  // 開設日
  OPENING_DATE:
    'Copyright © 2020 Cabinet Office, Government Of Japan. All Rights Reserved.',
};

/**
 * 本番ドメイン
 */
export const PROD_DOMAIN = '';

/**
 * 非ログイン用APIキー
 */
export const API_KEY = 'e33f5421bc3645be8a0dece6689fac2f';

/**
 * auth0設定情報(検証/開発)
 */
export const auth0_dev = {
  production: false,
  AUTH0_DOMAIN: 'auth.future-city.go.jp', // ApplicationsのDomain(auth0情報)
  AUTH0_CLIENT_ID: 'B6SDXEQQDO9OVUYFtBmkNbAvzJngxuVx', // ApplicationsのClient ID(auth0情報)
  AUDIENCE: 'https://sdgs-pf-matching-prod.jp.auth0.com/api/v2/', // APIsのAPI Audience(auth0情報)
  API_URL: [
    'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/*',
  ], // トークン付与対象APIエンドポイント
  API_URL_CUSTOM: [
    'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/*',
  ]
};

/**
 * auth0設定情報(本番)   auth0_devが呼ばれるため使用しない、本番リリース時はauth0_devのエンドポイントを書き換える
 */
export const auth0_prod = {
  production: false,
  AUTH0_DOMAIN: 'auth.future-city.go.jp', // ApplicationsのDomain(auth0情報)
  AUTH0_CLIENT_ID: 'B6SDXEQQDO9OVUYFtBmkNbAvzJngxuVx', // ApplicationsのClient ID(auth0情報)
  AUDIENCE: 'https://sdgs-pf-matching-prod.jp.auth0.com/api/v2/', // APIsのAPI Audience(auth0情報)
  API_URL: [

    'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/*',

  ], // トークン付与対象APIエンドポイント
  API_URL_CUSTOM: [
    'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/*',
    'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/*',
  ]
};

/**
 * 国際化（i18n）設定
 */
export const environment_i18n = {
  production: false,
  defaultLang: 'ja',
};
